namespace('compass.util');

compass.util.tracking = (function(undefined) {

	function getCookie(cookiename){      
		if(document.cookie.length > 0) {
			var startC = document.cookie.indexOf(cookiename+"=");
			if (startC != -1) {
				startC += cookiename.length+1;
				var endC = document.cookie.indexOf(";",startC);
				if(endC ==-1) { endC = document.cookie.length; }
				return unescape(document.cookie.substring(startC,  endC));
			}
		}
		return null;
	}

	function setCookie(cookieName, cookieValue, nDays)   {   
		var today = new Date();
		var expire = new Date();
		var days = nDays || 1;
		expire.setTime(today.getTime() + 3600000 * 24 * days);
		document.cookie = cookieName + "=" + escape(cookieValue) +
				";expires=" + expire.toGMTString();
	}

	var cookieMap = {
		'e' : 'EmailAddr',
		'j' : 'JobID',
		'l' : 'ListID',
		'jb' : 'BatchID',
		'u' : 'UrlID',
		'mid' : 'MemberID'
	};
   
	return {
		exactTargetLanding : function(options) {
			var opts = jQuery.extend({
				daysToExpire : 90
			}, options);

			var params = document.location.search.substring(1).split('&');
			for(var i = 0; i < params.length; i++) {
				var parts = params[i].split('=');
				var cookie = cookieMap[parts[0]];
				var value = parts[1];
				if(cookie) { setCookie(cookie, value); }
			}
		},

		exactTargetConversion : function(options) {
			var opts = jQuery.extend({
				conversionLinkId : 1,
				displayOrder : 1,
				linkAlias : 'Finish Page',
				dataSetAmount : 1,
				dataSetUnit : 'Dollars',
				dataSetAccumulate : true
			}, options);

			var url = 'https://click.exacttarget.com/conversion.aspx';
			var dataSet = '<data amt="' + opts.dataSetAmount + '" unit="' +
					opts.dataSetUnit + '" accumulate="' + opts.dataSetAccumulate + '"/>';

			// If the values are not found in a cookie, search for them in session-stored URL params
			var urlParams = compass.urlParams || {};

			var memberID = getCookie('MemberID') || urlParams['mid'];
			var jobID = getCookie('JobID') || urlParams['j'];
			var emailAddr = getCookie('EmailAddr') || urlParams['e'];
			var listID = getCookie('ListID') || urlParams['l'];
			var batchID = getCookie('BatchID') || urlParams['jb'];
			var urlID = getCookie('UrlID') || urlParams['u'];

			var xml = '<system>' +
				'<system_name>tracking</system_name>' +
				'<action>conversion</action>' +
				'<member_id>' + memberID + '</member_id>' +
				'<job_id>' + jobID + '</job_id>' +
				'<email>' + emailAddr + '</email>' +
				'<list>' + listID + '</list>' +
				'<BatchID>' + batchID + '</BatchID>' +
				'<original_link_id>' + urlID + '</original_link_id>' +
				'<conversion_link_id>' + opts.conversionLinkId + '</conversion_link_id>' +
				'<link_alias>' + opts.linkAlias + '</link_alias>' +
				'<display_order>' + opts.displayOrder + '</display_order>' +
				'<data_set>' + dataSet + '</data_set>' +
			'</system>';

			jQuery('body').append(jQuery.dom.img({ 
				src : url + '?xml=' + xml, 
				width : 1, 
				height : 1,
				alt : '',
				style : { 'border-style' : 'none' }
			}));
		},
		
		googleConversion : function(options) {
			//Default Adwords ID
			var opts = jQuery.extend({
				conversionId : 976187590,
				language : 'en',
				format : 1,
				color : 'ffffff',
				label : 'exYZCNrhywIQxuG90QM',
				value : 20.00
			}, options);

			var url = 'https://www.googleadservices.com/pagead/conversion/' + opts.conversionId + '/?value=' +
					opts.value + '&label=' + opts.label + '&guid=ON&script=0';

			jQuery('body').append(jQuery.dom.img({
				src : url,
				height : 1,
				width: 1,
				alt : '',
				style : { 'border-style' : 'none' }
			}));
			
			//Second Adwords ID, if provided and gtag has loaded properly
			if (compass.googleAdsConversionId && window.gtag) {
				gtag('event', 'conversion', {
					'send_to': ['ads'],
					'value': opts.value,
					'currency': opts.currency || 'USD',
					'transaction_id': ''
				});
			}
		}
	};

})();

